import React from 'react';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const HomePage = () => {
  return (
    <div>
      <HeroSection>
        <Container>
          <Row>
            <Col>
              <HeroTitle>AI-Powered Candidate Matching</HeroTitle>
              <HeroSubtitle>
                We eliminate noise in the hiring process by utilizing AI to match the perfect candidate to each role.
              </HeroSubtitle>
            </Col>
          </Row>
        </Container>
      </HeroSection>
      <HowItWorksSection>
        <Container>
          <SectionTitle>How It Works</SectionTitle>
          <Row>
            <Col>
              <StepNumber>1</StepNumber>
              <StepTitle>Define the Ideal Candidate Profile</StepTitle>
              <StepDescription>
                First, we gather information about your ideal candidate profile to understand your specific needs and requirements.
              </StepDescription>
            </Col>
            <Col>
              <StepNumber>2</StepNumber>
              <StepTitle>Review Candidate Profiles</StepTitle>
              <StepDescription>
                We present a number of candidate profiles to you through our web app. You can swipe left or right based on how well the candidate matches your ideal profile.
              </StepDescription>
            </Col>
            <Col>
              <StepNumber>3</StepNumber>
              <StepTitle>Initiate the Interview Process</StepTitle>
              <StepDescription>
                Once you've found the right candidate, you can add them to a pipeline, which initiates the interview process with the selected candidates.
              </StepDescription>
            </Col>
          </Row>
        </Container>
      </HowItWorksSection>
    </div>
  );
};

const HeroSection = styled.section`
  background-color: #f8f9fa;
  padding: 100px 0;
`;

const HeroTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: -0.5px;
  color: #1e1e1e;
  margin-bottom: 1rem;
`;

const HeroSubtitle = styled.h3`
  font-size: 24px;
  font-weight: 400;
  color: #1e1e1e;
  margin-bottom: 2rem;
`;

const HowItWorksSection = styled.section`
  padding: 100px 0;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: #1e1e1e;
  margin-bottom: 2rem;
  text-align: center;
`;

const StepNumber = styled.span`
  display: inline-block;
  width: 60px;
  height: 60px;
  line-height: 60px;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  background-color: #007bff;
  text-align: center;
  border-radius: 50%;
  margin-bottom: 1rem;
`;

const StepTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
  margin-bottom: 1rem;
`;

const StepDescription = styled.p`
  font-size: 1rem;
  color: #1e1e1e;
`;
